<script>
    export default {
        name: "PromotionsMixin",
        methods: {

            getAppliedCoupon () {
                return this.myData.appliedCouponCode;
            },
            getAppliedPromotion () {
                return this.myData.appliedPromotion;
            },
            setAppliedCoupon (eventData) {
                let promoCodeArr = eventData.value.split("_");
                let promoId = promoCodeArr[0];
                let couponCode = promoCodeArr[1];

                this.changeMyData({
                    appliedPromotion : promoId,
                    appliedCouponCode : couponCode
                })
            }
        }
    }
</script>

